// extracted by mini-css-extract-plugin
module.exports = {"PrivateButton":"PrivateButton_PrivateButton__237VL","privated":"PrivateButton_privated__rSbkA"};